import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "F:/Github/Web-Design-Helpers/docz-app/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import StyledGrid, { GridItem } from '../components/StyledGrid/StyledGrid';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "grid-concept"
    }}>{`Grid Concept`}</h2>
    <p>{`Building a fluid grid solution with mobile first approach using CSS in JS.`}</p>
    <p>{`The grid works with StyledGrid container and GridItem as the grid items.`}</p>
    <ul>
      <li parentName="ul">{`The immediate child of GridItem should be an HTMLElement.`}</li>
      <li parentName="ul">{`A StyledGrid should have at least one child.`}</li>
      <li parentName="ul">{`The gutters are done with `}<inlineCode parentName="li">{`padding-left`}</inlineCode>{` and `}<inlineCode parentName="li">{`padding-bottom`}</inlineCode>{` in the `}<inlineCode parentName="li">{`GridItem`}</inlineCode>{` and the `}<inlineCode parentName="li">{`StyledGrid`}</inlineCode>{` prevents the horizontal shift with a negative `}<inlineCode parentName="li">{`margin-left`}</inlineCode>{` and a negative `}<inlineCode parentName="li">{`margin-bottom`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`StyledGrid has following props available:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`
type TBreakpoints =
  | "mobileS"
  | "mobileM"
  | "mobileL"
  | "tablet"
  | "laptop"
  | "laptopL"
  | "desktop";

type TGutter = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "none";

interface IStyledGrid {
  /** fraction: flex-basis % */
  fraction?: number;
  verticalStretch?: boolean | TBreakpoints;
  /** auto: flex-basis */
  auto?: boolean | TBreakpoints;
  /** autoFill: flex-grow */
  autoFill?: boolean | TBreakpoints;
  jStart?: boolean | TBreakpoints;
  jCenter?: boolean | TBreakpoints;
  jEnd?: boolean | TBreakpoints;
  jBetween?: boolean | TBreakpoints;
  jAround?: boolean | TBreakpoints;
  aTop?: boolean | TBreakpoints;
  aCenter?: boolean | TBreakpoints;
  aEnd?: boolean | TBreakpoints;
  gutter?: TGutter;
  fractionWithBp?: string[];
  noWrap?: boolean | TBreakpoints;
}
`}</code></pre>
    <ul>
      <li parentName="ul">{`Most of the props have an optional string parameter which states the breakpoint (min-width)`}</li>
      <li parentName="ul">{`GridItem has following props available:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`enum EPositions {
  first = "first",
  last = "last",
}

interface IGridItem {
  fraction?: number;
  fractionWithBp?: string[];
  aTop?: boolean | TBreakpoints;
  aCenter?: boolean | TBreakpoints;
  aEnd?: boolean | TBreakpoints;
  position?: EPositions;
  pull?: boolean | TBreakpoints;
  push?: boolean | TBreakpoints;
}
`}</code></pre>
    <ul>
      <li parentName="ul">{`Named breakpoints available as per current theme are as follows:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`mobileS: 320
mobileM: 375
mobileL: 425
tablet: 768
laptop: 1024
laptopL: 1440
desktop: 2560
`}</code></pre>
    <h2 {...{
      "id": "size"
    }}>{`Size`}</h2>
    <Playground __position={0} __code={'<StyledGrid fractionWithBp={[\'1/2@tablet\', \'1/4@laptop\']}>\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid fractionWithBp={['1/2@tablet', '1/4@laptop']} mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "stretch"
    }}>{`Stretch`}</h3>
    <Playground __position={1} __code={'<StyledGrid verticalStretch fractionWithBp={[\'1/2@tablet\', \'1/4@laptop\']}>\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid verticalStretch fractionWithBp={['1/2@tablet', '1/4@laptop']} mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "fraction-power"
    }}>{`Fraction Power`}</h3>
    <Playground __position={2} __code={'<StyledGrid gutter=\"xs\">\n  <GridItem>\n    <div className=\"demo\">full</div>\n  </GridItem>\n  {Array.from(Array(2).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 2}>\n      <div className=\"demo\">1/2</div>\n    </GridItem>\n  ))}\n  {Array.from(Array(4).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 4}>\n      <div className=\"demo\">1/4</div>\n    </GridItem>\n  ))}\n  {Array.from(Array(5).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 5}>\n      <div className=\"demo\">1/5</div>\n    </GridItem>\n  ))}\n  {Array.from(Array(6).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 6}>\n      <div className=\"demo\">1/6</div>\n    </GridItem>\n  ))}\n  {Array.from(Array(7).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 7}>\n      <div className=\"demo\">1/7</div>\n    </GridItem>\n  ))}\n  {Array.from(Array(8).keys()).map(x => (\n    <GridItem key={x} fraction={1 / 8}>\n      <div className=\"demo\">1/8</div>\n    </GridItem>\n  ))}\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid gutter="xs" mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">full</div>
    </GridItem>
    {Array.from(Array(2).keys()).map(x => <GridItem key={x} fraction={1 / 2} mdxType="GridItem">
        <div className="demo">1/2</div>
      </GridItem>)}
    {Array.from(Array(4).keys()).map(x => <GridItem key={x} fraction={1 / 4} mdxType="GridItem">
        <div className="demo">1/4</div>
      </GridItem>)}
    {Array.from(Array(5).keys()).map(x => <GridItem key={x} fraction={1 / 5} mdxType="GridItem">
        <div className="demo">1/5</div>
      </GridItem>)}
    {Array.from(Array(6).keys()).map(x => <GridItem key={x} fraction={1 / 6} mdxType="GridItem">
        <div className="demo">1/6</div>
      </GridItem>)}
    {Array.from(Array(7).keys()).map(x => <GridItem key={x} fraction={1 / 7} mdxType="GridItem">
        <div className="demo">1/7</div>
      </GridItem>)}
    {Array.from(Array(8).keys()).map(x => <GridItem key={x} fraction={1 / 8} mdxType="GridItem">
        <div className="demo">1/8</div>
      </GridItem>)}
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-auto"
    }}>{`Grid Auto`}</h3>
    <Playground __position={3} __code={'<StyledGrid auto>\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid auto mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-stretch--auto"
    }}>{`Grid Stretch & Auto`}</h3>
    <Playground __position={4} __code={'<StyledGrid auto verticalStretch>\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid auto verticalStretch mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-fill"
    }}>{`Grid Fill`}</h3>
    <p>{`Add any number of items to a container`}</p>
    <Playground __position={5} __code={'<StyledGrid autoFill className=\"demo\">\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid autoFill className="demo" mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-stretch--fill"
    }}>{`Grid Stretch & Fill`}</h3>
    <Playground __position={6} __code={'<StyledGrid autoFill stretch>\n  <GridItem>\n    <div className=\"demo\">Item with some content</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      two lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid autoFill stretch mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item with some content</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        two lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h2 {...{
      "id": "alignment"
    }}>{`Alignment`}</h2>
    <h3 {...{
      "id": "grid-horizontal-alignment"
    }}>{`Grid Horizontal Alignment`}</h3>
    <Playground __position={7} __code={'<StyledGrid jStart>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jStart mdxType="StyledGrid">
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <Playground __position={8} __code={'<StyledGrid jCenter>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jCenter mdxType="StyledGrid">
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <Playground __position={9} __code={'<StyledGrid jEnd>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jEnd mdxType="StyledGrid">
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-vertical-alignment"
    }}>{`Grid Vertical Alignment`}</h3>
    <Playground __position={10} __code={'<StyledGrid fraction={1 / 3} aTop>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      three\n      <br />\n      lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid fraction={1 / 3} aTop mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        three
        <br />
        lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <Playground __position={11} __code={'<StyledGrid fraction={1 / 3} aCenter>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      three\n      <br />\n      lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid fraction={1 / 3} aCenter mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        three
        <br />
        lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <Playground __position={12} __code={'<StyledGrid fraction={1 / 3} aEnd>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">\n      Item\n      <br />\n      three\n      <br />\n      lines\n    </div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid fraction={1 / 3} aEnd mdxType="StyledGrid">
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        three
        <br />
        lines
      </div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "grid-item-vertical-alignment"
    }}>{`Grid Item Vertical Alignment`}</h3>
    <p>{`Align each item independently in the row`}</p>
    <Playground __position={13} __code={'<StyledGrid>\n  <GridItem fraction={1 / 4} aTop>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">\n      Item\n      <br />\n      three\n      <br />\n      lines\n    </div>\n  </GridItem>\n  <GridItem fraction={1 / 4} aCenter>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 4} aEnd>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid mdxType="StyledGrid">
    <GridItem fraction={1 / 4} aTop mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">
        Item
        <br />
        three
        <br />
        lines
      </div>
    </GridItem>
    <GridItem fraction={1 / 4} aCenter mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 4} aEnd mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h2 {...{
      "id": "distribution"
    }}>{`Distribution`}</h2>
    <h3 {...{
      "id": "space-between"
    }}>{`Space Between`}</h3>
    <Playground __position={14} __code={'<StyledGrid jBetween>\n  <GridItem fraction={1 / 6} aTop>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6} aCenter>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6} aEnd>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jBetween mdxType="StyledGrid">
    <GridItem fraction={1 / 6} aTop mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} aCenter mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} aEnd mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "space-around"
    }}>{`Space Around`}</h3>
    <Playground __position={15} __code={'<StyledGrid jAround>\n  <GridItem fraction={1 / 6} aTop>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6} aCenter>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem fraction={1 / 6} aEnd>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jAround mdxType="StyledGrid">
    <GridItem fraction={1 / 6} aTop mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} aCenter mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem fraction={1 / 6} aEnd mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h2 {...{
      "id": "ordering"
    }}>{`Ordering`}</h2>
    <h3 {...{
      "id": "item-first-position"
    }}>{`Item First Position`}</h3>
    <Playground __position={16} __code={'<StyledGrid jAround>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 1</div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 2</div>\n  </GridItem>\n  <GridItem position=\"first\" fraction={1 / 4}>\n    <div\n      className=\"demo\"\n      style={{ background: \'#587193\', fontWeight: 700, color: \'white\' }}\n    >\n      Item 3\n    </div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 4</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jAround mdxType="StyledGrid">
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 1</div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 2</div>
    </GridItem>
    <GridItem position="first" fraction={1 / 4} mdxType="GridItem">
      <div className="demo" style={{
            background: '#587193',
            fontWeight: 700,
            color: 'white'
          }}>
        Item 3
      </div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 4</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "item-last-position"
    }}>{`Item Last Position`}</h3>
    <Playground __position={17} __code={'<StyledGrid jAround>\n  <GridItem position=\"last\" fraction={1 / 4}>\n    <div\n      className=\"demo\"\n      style={{ background: \'#587193\', fontWeight: 700, color: \'white\' }}\n    >\n      Item 1\n    </div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 2</div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 3</div>\n  </GridItem>\n  <GridItem fraction={1 / 4}>\n    <div className=\"demo\">Item 4</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid jAround mdxType="StyledGrid">
    <GridItem position="last" fraction={1 / 4} mdxType="GridItem">
      <div className="demo" style={{
            background: '#587193',
            fontWeight: 700,
            color: 'white'
          }}>
        Item 1
      </div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 2</div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 3</div>
    </GridItem>
    <GridItem fraction={1 / 4} mdxType="GridItem">
      <div className="demo">Item 4</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "pull--push-item"
    }}>{`Pull & Push Item`}</h3>
    <p>{`When using pull & push, use noWrap to prevent items to wrap on new row.`}</p>
    <Playground __position={18} __code={'<StyledGrid noWrap>\n  <GridItem pull>\n    <div className=\"demo\">Item pull</div>\n  </GridItem>\n  <GridItem>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n  <GridItem push>\n    <div className=\"demo\">Item push</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid noWrap mdxType="StyledGrid">
    <GridItem pull mdxType="GridItem">
      <div className="demo">Item pull</div>
    </GridItem>
    <GridItem mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
    <GridItem push mdxType="GridItem">
      <div className="demo">Item push</div>
    </GridItem>
  </StyledGrid>
    </Playground>
    <h3 {...{
      "id": "nested-grid"
    }}>{`Nested Grid`}</h3>
    <Playground __position={19} __code={'<StyledGrid verticalStretch>\n  <GridItem fractionWithBp={[\'1/2@tablet\']}>\n    <StyledGrid verticalStretch>\n      <GridItem fractionWithBp={[\'1/2@tablet\']}>\n        <div className=\"demo\">Item</div>\n      </GridItem>\n      <GridItem fractionWithBp={[\'1/2@laptop\']}>\n        <StyledGrid verticalStretch>\n          <GridItem fractionWithBp={[\'1/2@laptop\']}>\n            <div className=\"demo\">Item</div>\n          </GridItem>\n          <GridItem fractionWithBp={[\'1/2@laptop\']}>\n            <div className=\"demo\">\n              Item\n              <br />2 lines\n            </div>\n          </GridItem>\n        </StyledGrid>\n      </GridItem>\n      <GridItem fractionWithBp={[\'1/2@tablet\']}>\n        <div className=\"demo\">Item</div>\n      </GridItem>\n      <GridItem fractionWithBp={[\'1/2@tablet\']}>\n        <div className=\"demo\">Item</div>\n      </GridItem>\n    </StyledGrid>\n  </GridItem>\n  <GridItem fractionWithBp={[\'1/2@tablet\']}>\n    <div className=\"demo\">Item</div>\n  </GridItem>\n</StyledGrid>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StyledGrid,
      GridItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StyledGrid verticalStretch mdxType="StyledGrid">
    <GridItem fractionWithBp={['1/2@tablet']} mdxType="GridItem">
      <StyledGrid verticalStretch mdxType="StyledGrid">
        <GridItem fractionWithBp={['1/2@tablet']} mdxType="GridItem">
          <div className="demo">Item</div>
        </GridItem>
        <GridItem fractionWithBp={['1/2@laptop']} mdxType="GridItem">
          <StyledGrid verticalStretch mdxType="StyledGrid">
            <GridItem fractionWithBp={['1/2@laptop']} mdxType="GridItem">
              <div className="demo">Item</div>
            </GridItem>
            <GridItem fractionWithBp={['1/2@laptop']} mdxType="GridItem">
              <div className="demo">
                Item
                <br />2 lines
              </div>
            </GridItem>
          </StyledGrid>
        </GridItem>
        <GridItem fractionWithBp={['1/2@tablet']} mdxType="GridItem">
          <div className="demo">Item</div>
        </GridItem>
        <GridItem fractionWithBp={['1/2@tablet']} mdxType="GridItem">
          <div className="demo">Item</div>
        </GridItem>
      </StyledGrid>
    </GridItem>
    <GridItem fractionWithBp={['1/2@tablet']} mdxType="GridItem">
      <div className="demo">Item</div>
    </GridItem>
  </StyledGrid>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      